import { FC } from "react";
import { Coins } from "lucide-react";
import "./coinsEstimateIcon.scss";

/**
 * 积分预估图标：Lucide `coins` 轮廓 + 琥珀色强调（原 CreditsLucideCoinsIcon 的去 Header 化替代）。
 * 供各工作台「预计消耗 N 积分」提示复用。
 */
export const CoinsEstimateIcon: FC = () => (
  <Coins size={14} strokeWidth={2} className="coins-estimate-icon" aria-hidden />
);
